//日志管理

//引入接口文档
import req from '@/utils/req.js'


//日志管理列表分页查询
export function api_feign_log(params) {
    return req.get("/dsicm-data-base/feign/operate-log/page", params);
}

